module.exports = __webpack_public_path__ + "img/bars.ca49bba4.svg";